// SARKY: Shopify's native variant-picker marks an unavailable option value's
// <input> as aria-disabled="true" (see snippets/variant-main-picker.liquid)
// but never sets the real disabled attribute -- assets/variant-picker.js
// only reacts to the input's own native 'change' event, so a real click (or
// a keyboard Space/Enter activation) still checks the input and fires
// 'change', letting a customer "select" a Color/Size combination Shopify
// itself cannot sell. Billy's explicit rule: a faded/unavailable size must
// stay visible and focusable (so keyboard/screen-reader users can still
// discover it and its disabled state) but must never actually become the
// selected option, and the previously valid selection must not change.
//
// Delegated on document in the CAPTURE phase -- same pattern as
// assets/sarky-card-swatch-guard.js -- so this runs before the input's own
// default "check this radio" action and before variant-picker.js's
// bubble-phase 'change' listener ever sees anything. Calling
// preventDefault() on a click that targets (or bubbles up from) an
// aria-disabled input's <label> cancels the label's default action of
// forwarding a click to its control, so the radio is never checked and
// 'change' never fires -- the hidden variant id stays exactly what it was.
// Nothing here reads or guesses inventory: it only reads the aria-disabled
// attribute Shopify's own option-availability computation already wrote.
//
// Native radio-button keyboard activation (Space/Enter while focused)
// resolves to a real 'click' event in every current browser, so the single
// click-phase guard below already covers both mouse/touch and keyboard.
document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;

    const label = event.target.closest('.sarky-variant-picker label');
    if (!label) return;

    if (label.querySelector('input[aria-disabled="true"]')) {
      event.preventDefault();
      event.stopPropagation();
    }
  },
  true,
);
